import * as React from 'react';

import { Row as AntdRow, Col } from 'antd';
import { Row, Space, Text } from 'farmhub-ui-core';
import styled from 'styled-components';

import { useAppSelector } from 'app';
import { CertificationSelected, CheckFilterItemSkeleton } from 'components';
import { selectCertification } from 'slice';
import { getDummyArray } from 'utils/function';

import { MobileWrapper, SectionDataMobile } from './styles';

interface SelectCertificatesAndCategoriesStepProps {
  data: any;
  isLoadingCertification: boolean;
  handleClickCertifications: (e: string) => void;
  handleSelectAllOrDeleteCertificates: () => void;
}

const SelectCertificatesAndCategoriesStepMobile = ({
  data,
  isLoadingCertification,
  handleClickCertifications,
  handleSelectAllOrDeleteCertificates,
}: SelectCertificatesAndCategoriesStepProps): JSX.Element => {
  const certificationList = useAppSelector(selectCertification);

  return (
    <MobileWrapper>
      <Row justifyContent="space-between">
        <Text color="dark" weight="bold">
          Lựa chọn chứng chỉ ({data.certificationIDs.length})
        </Text>
        <DeleteText onClick={handleSelectAllOrDeleteCertificates}>
          {data.certificationIDs.length > 0 ? 'Xóa tất cả' : 'Chọn tất cả'}
        </DeleteText>
      </Row>
      <Space height={12} />
      <SectionDataMobile>
        <AntdRow gutter={[12, 12]}>
          {isLoadingCertification
            ? getDummyArray(12).map(item => (
                <Col span={8}>
                  <CheckFilterItemSkeleton key={item.key} />
                </Col>
              ))
            : certificationList.list.map((item: any, index: number) => (
                <Col
                  span={8}
                  onClick={() => handleClickCertifications(item.id)}
                >
                  <CertificationSelected
                    key={item.id}
                    image={item.logo}
                    selected={data.certificationIDs.includes(item.id)}
                    title={item.name}
                  />
                </Col>
              ))}
        </AntdRow>
      </SectionDataMobile>
    </MobileWrapper>
  );
};

export default SelectCertificatesAndCategoriesStepMobile;

const DeleteText = styled.span`
  font-weight: ${p => p.theme.font.weight.regular};
  font-size: ${p => p.theme.font.size.xs};
  text-decoration-line: underline;
  color: #ff6347;
  cursor: pointer;

  text-underline-offset: 3px;
`;
